<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between>
      <h2>Mass add VAT</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <div>
      <v-layout column class="my-4">
        <v-select
          :items="vatItems"
          class="pt-0"
          :disabled="!this.selectedCompanyInfo.vatRates || this.selectedCompanyInfo.vatRates.length === 0 ? true : false"
          v-model="vatRate" />
      </v-layout>
      <v-layout row justify-end>
        <v-btn color="primary" class="mx-0" @click="submitVat()">Submit</v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
  export default {
    props: ['selectedCompanyInfo'],
    data: () => ({
      vatRate: null,
      err: '',
    }),
    computed: {
      vatItems() {
        return this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0 ?
          [{ text: 'Not selected', value: null }, ...this.selectedCompanyInfo.vatRates.map(vatRateItem => ({ text: `${vatRateItem}`, value: `${vatRateItem}` }))] :
          [{ value: 'null', text: 'null' }];
      },
    },
    methods: {
      submitVat() {
        this.$emit('submit', this.vatRate);
      },
    },
  };
</script>

<style lang="scss">

  .checkbox-wrap {
    width: 100%;
    .input-group {
      min-width: 140px;
      flex: none;
      width: auto;
      width: fit-content;
      padding: 0 32px;
      .input-group__details {
        display: none !important;
      }
      label {
        position: relative !important;
        left: 0;
        max-width: 220px;
        width: auto;
        width: fit-content;
        overflow: hidden;
      }
      .input-group__input {
        position: absolute;
        left: 0;
        top: 0;
        width: 32px;
        flex: 0;
      }
      --selection-controls {
        display: inline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MassVATAddModal.vue?b9cf4074